import { render } from "./EditorToolbar.vue?vue&type=template&id=16d6c1e9&scoped=true"
import script from "./EditorToolbar.vue?vue&type=script&lang=js"
export * from "./EditorToolbar.vue?vue&type=script&lang=js"

import "./EditorToolbar.vue?vue&type=style&index=0&id=16d6c1e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d6c1e9"]])

export default __exports__